export default __webpack_public_path__ + "static/media/ify_logo.f172c247.png";